// Redux Form
import { SubmissionError } from 'redux-form';

// Fetch request
import fetch from '../../core/fetch';

// Locale
import messages from '../../locale/messages';

// Redux Action
import { getListingDataStep3 } from '../../actions/getListingDataStep3';
import { manageListingSteps } from '../../actions/manageListingSteps';
import { setLoaderStart, setLoaderComplete } from '../../actions/loader/loader';

// For Redirect
import history from '../../core/history';

async function updateStep3(values, dispatch) {

  let weeklyDiscount = values.weeklyDiscount != '' ? values.weeklyDiscount : 0;
  let monthlyDiscount = values.monthlyDiscount != '' ? values.monthlyDiscount : 0;
  let cleaningPrice = values.cleaningPrice != '' && values.cleaningPrice ? values.cleaningPrice : 0;
  let service_price_hour = values.service_price_hour != '' ? values.service_price_hour : 0;
  let service_price_qm = values.service_price_qm != '' ? values.service_price_qm : 0;
  let service_price_kg = values.service_price_kg != '' ? values.service_price_kg : 0;
  let service_price_palette = values.service_price_palette != '' ? values.service_price_palette : 0;
  // let variables = Object.assign({}, values, { weeklyDiscount, monthlyDiscount, cleaningPrice });


  let id = values.id;
  let houseRules = values.houseRules;
  let bookingNoticeTime = values.bookingNoticeTime;
  let checkInStart = values.checkInStart;
  let checkInEnd = values.checkInEnd;
  let maxDaysNotice = values.maxDaysNotice;
  let maxDaysNoticeStart = values.maxDaysNoticeStart;
  let maxDaysNoticeEnd = values.maxDaysNoticeEnd;
  let minNight = values.minNight;
  let maxNight = values.maxNight;
  let basePrice = values.basePrice;
  let qmPrice = values.qmPrice;
  let nkPrice = values.nkPrice;
  let currency = values.currency;
  let blockedDates = values.blockedDates;
  let bookingType = values.bookingType;
  let cancellationPolicy = values.cancellationPolicy;
  let services = values.services;
  let service_description = values.service_description;
  let monthlyPay = values.monthlyPay;

  let variables = Object.assign({}, {
    weeklyDiscount, monthlyDiscount, cleaningPrice,
    id, houseRules, bookingNoticeTime,
    checkInStart, checkInEnd, maxDaysNotice, maxDaysNoticeStart, maxDaysNoticeEnd,
    minNight, maxNight, basePrice, nkPrice, qmPrice,
    currency, blockedDates, bookingType,
    cancellationPolicy, services, service_price_hour, service_price_kg, service_price_qm, service_price_palette,service_description, monthlyPay
  });
  
  
  dispatch(setLoaderStart('updateListing'));
  const query = `query (
  	$id: Int,
    $houseRules: [String],
    $bookingNoticeTime:String,
    $checkInStart:String,
    $checkInEnd:String,
    $maxDaysNotice:String,
    $maxDaysNoticeStart:String,
    $maxDaysNoticeEnd:String,
    $minNight:Int,
    $maxNight:Int,
    $basePrice:Float,
    $nkPrice:Float,
    $qmPrice:Float,
    $cleaningPrice:Float,
    $services:String,
    $service_description:String,
    $service_price_hour:Float,
    $service_price_qm:Float,
    $service_price_kg:Float,
    $service_price_palette:Float,
    $monthlyPay:Boolean,
    $currency:String,
    $weeklyDiscount:Int,
    $monthlyDiscount:Int,
    $blockedDates: [String],
    $bookingType: String!,
    $cancellationPolicy: Int,
  ) {
      updateListingStep3 (
        id: $id,
        houseRules: $houseRules,
        bookingNoticeTime:$bookingNoticeTime,
        checkInStart:$checkInStart,
        checkInEnd:$checkInEnd,
        maxDaysNotice:$maxDaysNotice,
        maxDaysNoticeStart:$maxDaysNoticeStart,
        maxDaysNoticeEnd:$maxDaysNoticeEnd,
        minNight:$minNight,
        maxNight:$maxNight,
        basePrice:$basePrice,
        nkPrice:$nkPrice,
        qmPrice:$qmPrice,
        cleaningPrice:$cleaningPrice,
        currency:$currency,
        weeklyDiscount:$weeklyDiscount,
        monthlyDiscount:$monthlyDiscount,
        blockedDates: $blockedDates,
        bookingType: $bookingType,
        cancellationPolicy: $cancellationPolicy
        services: $services
        service_description: $service_description
        service_price_hour: $service_price_hour
        service_price_qm: $service_price_qm
        service_price_kg: $service_price_kg
        service_price_palette: $service_price_palette
        monthlyPay: $monthlyPay
      ) {
        status
      }
    }`;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables
    }),
    credentials: 'include'
  });

  const { data } = await resp.json();


  if (data && data.updateListingStep3 != undefined) {
    if (data.updateListingStep3.status == "success") {
      await dispatch(getListingDataStep3(values.id));
      // await dispatch(manageListingSteps(values.id, 3));
      await dispatch(manageListingSteps(values.id, 3));

      await dispatch(setLoaderComplete('updateListing'));
      if(values.isApproved) {
        history.push('/spaces');
      } else {
        history.push('/become-a-host/' + values.id + '/home');
      }
      
    } else if (data.updateListingStep3.status == "notLoggedIn") {
      dispatch(setLoaderComplete('updateListing'));
      throw new SubmissionError({ _error: messages.notLoggedIn });
    } else {
      dispatch(setLoaderComplete('updateListing'));
      throw new SubmissionError({ _error: messages.somethingWentWrong });
    }
  } else {
    dispatch(setLoaderComplete('updateListing'));
    throw new SubmissionError({ _error: messages.somethingWentWrong });
  }

}

export default updateStep3;
